export function formatCount(value) {
  if (!value) return `0 Appointments`
  if (value === 1) return `1 Appointment`
  return `${value} Appointments`
}
